import api from '@/com/system/api'

class ServiceGeneral {

  async betaSignup (_user) {
    try {
      const res = await api.post('/v1/requestors', _user)
      return res
    } catch {
      return false
    }
  }

  async getBetaSignups () {
    try {
      const res = await api.getAdmin('/v1/requestors')
      return res
    } catch {
      return false
    }
  }

}
export default new ServiceGeneral()